import { ReactComponent as TimeCodeIcon } from 'assets/icons/timecode-player.svg'
import { Flex } from 'components/common/Flex'
import { deviceWidth } from 'constants/responsive'
import dayjs from 'dayjs'
import { getBookmarksWithPagination_getBookmarksWithPagination_items } from 'graphql/query/__generated__/getBookmarksWithPagination'
import { convertMsInSecs } from 'helpers/convertMsInSecs'
import { getDateWithoutTimezone } from 'helpers/getDateWithoutTimezone'
import { memo } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  ContentWrapper,
  DateText,
  Description,
  Image,
  Number as OrderedNumber,
  SeriesTitle,
  ShiurContainer,
  ShiurTimeCodeText,
  ShiurTimeCodeWrapper,
  ShiurWrapper,
  Text,
  Title,
  TitleRow,
  Wrapper,
} from './styled'

type Props = getBookmarksWithPagination_getBookmarksWithPagination_items & { onClick?: () => void }

function BookmarkCard({ shiur, text, timecode, createdAt, onClick }: Props) {
  const navigate = useNavigate()

  const isMobile = window.innerWidth < Number(deviceWidth.laptopL.match(/(\d+)/)[0])
  return (
    <Wrapper onClick={onClick}>
      <ShiurWrapper>
        <ShiurContainer>
          <Image src={`${process.env.REACT_APP_AWS_S3_URL}${shiur.series.coverUrl}`} />
          <ContentWrapper>
            <Description>
              <SeriesTitle onClick={() => navigate(`/series/${shiur.series.seriesId}`)} color={shiur.series.titleColor}>
                {shiur.series.title}
              </SeriesTitle>
              {shiur.topic?.title && `∙${shiur.topic.title}`}
            </Description>
            <TitleRow>
              {!!shiur.orderedNum && <OrderedNumber>Shiur {shiur.orderedNum}.</OrderedNumber>}
              <Title>{shiur.title}</Title>
            </TitleRow>
            {shiur.subtitle && <Description>{shiur.subtitle}</Description>}
          </ContentWrapper>
        </ShiurContainer>
        <Flex alignCenter>
          {!isMobile && (
            <>
              <DateText>
                {getDateWithoutTimezone(createdAt).toDate().toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                })}
              </DateText>
              <ShiurTimeCodeWrapper>
                <TimeCodeIcon />
                <ShiurTimeCodeText>{dayjs.duration(convertMsInSecs(timecode), 's').format('mm:ss')}</ShiurTimeCodeText>
              </ShiurTimeCodeWrapper>
            </>
          )}
        </Flex>
      </ShiurWrapper>
      <Text>{text}</Text>
      {isMobile && (
        <Flex justifyBetween alignCenter>
          <ShiurTimeCodeWrapper>
            <TimeCodeIcon />
            <ShiurTimeCodeText>{dayjs.duration(convertMsInSecs(timecode), 's').format('mm:ss')}</ShiurTimeCodeText>
          </ShiurTimeCodeWrapper>
          <DateText>
            {getDateWithoutTimezone(createdAt).toDate().toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            })}
          </DateText>
        </Flex>
      )}
    </Wrapper>
  )
}

export default memo(BookmarkCard)
